export default function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/graphql/jsutils/devAssert.mjs
// module id = +gJO
// module chunks = 9